import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, IconButton, useTheme, TextField, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, DialogContentText } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { tokens } from '../../../theme';
import Header from "../../../components/Header";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { addsidebar, AllSlideBarCategoryByAdmin, deletesidebar, editsidebar } from '../../../redux/slice/SidebarName.slice';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Image_URL } from '../../../utils/baseURL';

const SidebarGrid = ({ data, columns }) => {
    if (!data || !Array.isArray(data)) {
        return <div>No data availble...</div>;
    }
    return (
        <DataGrid
            rows={data}
            columns={columns}
            components={{ Toolbar: GridToolbar }}
            pageSize={5}
            rowsPerPageOptions={[5, 10]}
            getRowId={(row) => row?._id}
            density="compact"
            autoHeight
            sx={{
                "@media print": {
                    "& .MuiDataGrid-toolbarContainer": {
                        display: "none !important"
                    },
                    "& .MuiDataGrid-root": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-cell": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-footerContainer": {
                        color: "black !important",
                    },
                    "& .css-7ms3qr-MuiTablePagination-displayedRows": {
                        color: "black !important",
                    },
                },
            }}
        />
    );
};

export default function AddSidebar() {
    const theme = useTheme();
    const dispatch = useDispatch();
    const colors = tokens(theme.palette.mode);
    const [open, setOpen] = useState(false);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deletesidebarData, setDeletesidebarData] = useState(null);
    const [update, setUpdate] = useState(null);
    const imgUrl = Image_URL;
    const [openView, setOpenView] = React.useState(false);
    const [viewData, setViewData] = useState(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const SideBar = useSelector((state) => state.sidebar.sidebar);
    const [changeimage, setchangeimage] = React.useState([{ changed: false, index: 0 }]);
    const isMobile = useMediaQuery('(max-width:500px)');


    const initialValues = {
        categoryName: '',
        slideBarImage: '',
        subsidebaradd: [{ subcategoryName: '', subcategoryimages: '' }],
        subcategoryimages: [],
        to: ''
    };

    const sideBarSchema = Yup.object({
        categoryName: Yup.string().required('Category Name is required'),
        slideBarImage: Yup.string().required('SlideBar Image is required'),
    });

    useEffect(() => {
        dispatch(AllSlideBarCategoryByAdmin());
    }, []);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        formik.resetForm();
        setUpdate(null);
    };

    const handleDelete = (id) => {
        setDeletesidebarData(id);
        setDeleteConfirmOpen(true);
    };

    const confirmDelete = () => {
        if (deletesidebarData) {
            dispatch(deletesidebar(deletesidebarData));
            setDeleteConfirmOpen(false);
            setDeletesidebarData(null);
        }
    }
    const cancelDelete = () => {
        setDeleteConfirmOpen(false);
        setDeletesidebarData(null);
    }

    const handleEdit = (data) => {
        formik.setValues(data);
        setsubsidebar(data.subsidebaradd);
        const initialChangeImage = data.subsidebaradd.map((payment, index) => ({
            changed: false,
            index: index,
        }));
        setchangeimage(initialChangeImage);
        setOpen(true);
        setUpdate(data._id);
    };


    const handleClickOpenView = () => {
        setOpenView(true);
    };

    const handleCloseView = () => {
        setOpenView(false);
    };

    const handleView = (data) => {
        handleClickOpenView();
        setViewData(data)
    }

    const columns = useMemo(() => [
        {
            field: 'slideBarImage', headerName: 'Icon', width: 200,
            renderCell: (params) => {
                const imageUrl = `${imgUrl}/${params.row.slideBarImage}`;
                return (
                    <img
                        style={{ width: '30px', height: '30px', objectFit: 'cover', objectPosition: 'center center', filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none' }}
                        src={imageUrl}
                        alt="avatar"
                        onError={(e) => { e.target.onerror = null; e.target.src = ''; }}
                    />
                );
            }
        },
        { field: 'categoryName', headerName: 'Sidebar Name', width: 200 },
        {
            field: 'Action',
            headerName: 'Action',
            width: 130,
            renderCell: (params) => (
                <>
                    <IconButton aria-label="view" onClick={() => handleView(params.row)}>
                        <RemoveRedEyeIcon />
                    </IconButton>
                    <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
                        <EditIcon />
                    </IconButton>
                </>
            )
        }
    ], [theme.palette.mode]);


    const [subsidebar, setsubsidebar] = useState(initialValues.subsidebaradd);


    const handlesubsidebar = () => {
        setsubsidebar([...subsidebar, { subcategoryName: '', subcategoryimages: '' }]);
        setchangeimage(prev => [...prev, { changed: false, index: subsidebar.length }]);
        setFieldValue(`subcategoryimages.[${subsidebar.length}]`, '');
    };


    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: sideBarSchema,
        onSubmit: (values, { resetForm }) => {
            const filteredSubsidebarAdd = values.subsidebaradd.filter(sub => sub.subcategoryName || sub.subcategoryimages);

            const submissionvalues = {
                ...values,
                subsidebaradd: filteredSubsidebarAdd,
                subcategoryimages: values.subcategoryimages,
            };

            if (update) {
                dispatch(editsidebar({
                    _id: update,
                    ...submissionvalues,
                    subsidebaradd: submissionvalues.subsidebaradd.map((detail) => ({
                        ...detail,
                        subcategoryimages: detail.subcategoryimages instanceof File ? detail.subcategoryimages.name : detail.subcategoryimages,
                    })) || null,
                }));
            } else {
                dispatch(addsidebar(submissionvalues));
            }
            resetForm();
            handleClose();
        }

    });

    const { handleSubmit, handleChange, handleBlur, values, errors, touched, setFieldValue } = formik;

    return (
        <Box m="2px">
            <Header
                title="SIDE BAR"
                subtitle="Manage Your Side Bar Here"
            />
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleClickOpen}>
                    Add Side Bar
                </Button>
            </Box>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{update ? 'Edit Sidebar' : 'Add Sidebar'}</DialogTitle>
                <form onSubmit={handleSubmit}>
                    <DialogContent sx={{ minWidth: 600 }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                            {values.slideBarImage && (
                                <img
                                    src={typeof values.slideBarImage === 'string'
                                        ? ` ${imgUrl}/${values.slideBarImage}`
                                        : (values.slideBarImage instanceof File ? URL.createObjectURL(values.slideBarImage) : '')}
                                    alt="avatar"
                                    width="50"
                                    height="50"
                                    style={{ objectFit: 'cover', borderRadius: '5px' }}
                                />
                            )}
                            <Button
                                variant="contained"
                                component="label"
                                sx={{ marginLeft: '10px', width: '200px', height: '50px' }}
                            >
                                Upload Icon
                                <input
                                    type="file"
                                    hidden
                                    id="slideBarImage"
                                    name="slideBarImage"
                                    onChange={(event) => {
                                        setFieldValue("slideBarImage", event.currentTarget.files[0]);
                                    }}
                                    onBlur={handleBlur}
                                />
                            </Button>
                            <TextField
                                margin="dense"
                                id="categoryName"
                                name="categoryName"
                                label="Enter Category Name"
                                type="text"
                                fullWidth
                                variant="filled"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.categoryName}
                                error={touched.categoryName && Boolean(errors.categoryName)}
                                helperText={touched.categoryName && errors.categoryName}
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                                sx={{ marginLeft: '10px' }}
                                disabled={!!update}
                            />
                        </div>
                        {subsidebar && subsidebar.length > 0 && subsidebar.map((subsidebardata, index) => (
                            <>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                    {changeimage[index]?.changed ? (
                                        values.subcategoryimages?.[index] && (
                                            <img
                                                src={values.subcategoryimages[index] instanceof File
                                                    ? URL.createObjectURL(values.subcategoryimages[index])
                                                    : `${imgUrl}/${values.subcategoryimages[index]}`}
                                                alt="avatar"
                                                width="50"
                                                height="50"
                                                style={{ objectFit: 'cover', borderRadius: '5px' }}
                                            />
                                        )
                                    ) : (
                                        values.subsidebaradd?.[index]?.subcategoryimages && (
                                            <img
                                                src={`${imgUrl}/${values.subsidebaradd[index].subcategoryimages}`}
                                                alt="avatar"
                                                width="50"
                                                height="50"
                                                style={{ objectFit: 'cover', borderRadius: '5px' }}
                                            />
                                        )
                                    )}
                                    <Button
                                        variant="contained"
                                        component="label"
                                        sx={{ marginLeft: '10px', width: '200px', height: '50px' }}
                                    >
                                        Upload Sub Icon
                                        <input
                                            type="file"
                                            hidden
                                            id={`subcategoryimages.[${index}]`}
                                            name={`subcategoryimages.[${index}]`}
                                            multiple='multiple'
                                            onChange={e => {
                                                const files = Array.from(e.target.files);
                                                setFieldValue(`subcategoryimages.[${index}]`, files[0]);
                                                setchangeimage(prev => prev.map((item, idx) =>
                                                    idx == index ? { ...item, changed: true } : item
                                                ));
                                            }}
                                            onBlur={handleBlur}
                                        />
                                    </Button>
                                    <TextField
                                        margin="dense"
                                        name={`subsidebaradd.${index}.subcategoryName`}
                                        label="Enter Sub Category Name"
                                        type="text"
                                        fullWidth
                                        variant="filled"
                                        onChange={e => setFieldValue(`subsidebaradd[${index}].subcategoryName`, e.target.value)}
                                        onBlur={handleBlur}
                                        value={values.subsidebaradd?.[index]?.subcategoryName || ''}
                                        error={touched.subsidebaradd?.[index]?.subcategoryName && Boolean(errors.subsidebaradd?.[index]?.subcategoryName)}
                                        helperText={touched.subsidebaradd?.[index]?.subcategoryName && errors.subsidebaradd?.[index]?.subcategoryName}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                        sx={{ marginLeft: '10px' }}
                                        disabled={!!update}
                                    />
                                </div>
                            </>
                        ))}
                        <Box display="flex" justifyContent="flex-end" m={1}>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<AddIcon />}
                                onClick={handlesubsidebar}
                                disabled={!!update}
                            >
                                Add Sub Sidebar
                            </Button>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} style={{ color: theme.palette.text.primary }}>Cancel</Button>
                        <Button type="submit" style={{ color: theme.palette.text.primary }}>{update ? 'Update' : 'Add'}</Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Box
                height="75vh"
                sx={useMemo(() => ({
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },

                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                        fontSize: "13px !important",
                    },

                }), [colors])}
            >
                <SidebarGrid
                    data={SideBar}
                    columns={columns} />
            </Box>

            <Dialog
                fullScreen={fullScreen}
                open={openView}
                onClose={handleCloseView}
                aria-labelledby="responsive-dialog-title"
                maxWidth={"sm"}
                fullWidth
            >
                <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: "center", fontWeight: 'bold', fontSize: '18px' }}>
                    {"Sidebar Details"}
                </DialogTitle>
                <DialogContent style={{ backgroundColor: theme.palette.background.purple }}>
                    <DialogContentText>
                        {console.log("viewData", viewData)}

                        <div>
                            <p style={{
                                backgroundColor: theme.palette.background.light,
                                marginBottom: '2px',
                                padding: '10px',
                                display: 'flex', alignItems: 'center',
                            }}>
                                <strong>SideBar Image : </strong>
                                <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px', gap: '10px' }}>
                                    <img
                                        style={{
                                            width: '30px',
                                            height: '30px',
                                            objectFit: 'cover',
                                            objectPosition: 'center center',
                                            filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none'
                                        }}
                                        src={`${imgUrl}/${viewData?.slideBarImage}?t=${new Date().getTime()}`}
                                        alt="sidebar icon"
                                        onError={(e) => { e.target.onerror = null; e.target.src = ''; }}
                                    />
                                </div>
                            </p>
                            <p style={{
                                backgroundColor: theme.palette.background.light,
                                marginBottom: '10px',
                                padding: '10px'
                            }}>
                                <strong>Category Name : </strong>
                                <span style={{ wordBreak: 'break-word' }}>{viewData?.categoryName}</span>
                            </p>

                            {
                                viewData?.subsidebaradd.length > 0 && (
                                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Sub Category Images</th>
                                                <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Sub Category Name</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {viewData?.subsidebaradd?.map((Kit, index) => (
                                                <tr key={index}>
                                                    <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                                        <img
                                                            style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                objectFit: 'cover',
                                                                objectPosition: 'center center',
                                                                filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none'
                                                            }}
                                                            src={`${imgUrl}/${Kit?.subcategoryimages}?t=${new Date().getTime()}`}
                                                            alt="sub sidebar icon"
                                                            onError={(e) => { e.target.onerror = null; e.target.src = 'fallback-image-url'; }}
                                                        />
                                                    </td>
                                                    <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                                        {Kit?.subcategoryName || 'N/A'}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}

                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                    <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteConfirmOpen} onClose={cancelDelete}>
                <DialogContent>
                    Are you sure you want to delete this side bar?
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDelete} style={{ color: theme.palette.text.primary }}>No</Button>
                    <Button onClick={confirmDelete} style={{ color: theme.palette.text.primary }}>Yes</Button>
                </DialogActions>
            </Dialog>
        </Box >
    );
}
